<template>
  <v-form>
    <v-container class="mb-4">
      <v-subheader>
        <v-icon class="mr-2">mdi-account</v-icon>
        Dados do usuario
      </v-subheader>
      <v-row>
        <v-col cols="12" sm="8">
          <v-text-field
            outlined
            hide-details
            label="Nome"
            class="required"
            maxlength="150"
            :error="$v.empresa.usuario.nome.$error"
            @blur="$v.empresa.usuario.nome.$touch()"
            v-model="empresa.usuario.nome"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            outlined
            hide-details
            label="CPF"
            class="required"
            v-mask="'###.###.###-##'"
            :error="$v.empresa.usuario.cpf.$error"
            @blur="$v.empresa.usuario.cpf.$touch()"
            v-model="empresa.usuario.cpf"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="8">
          <v-text-field
            outlined
            hide-details
            label="E-mail"
            class="required"
            maxlength="150"
            :error="$v.empresa.usuario.email.$error"
            @blur="$v.empresa.usuario.email.$touch()"
            v-model="empresa.usuario.email"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            outlined
            hide-details
            label="Telefone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            v-model="empresa.usuario.telefone"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            outlined
            label="Senha"
            class="required"
            type="password"
            minlength="8"
            maxlength="30"
            :messages="passwordMessages"
            autocomplete="new-password"
            :error="$v.empresa.usuario.password.$error"
            @blur="$v.empresa.usuario.password.$touch()"
            v-model="empresa.usuario.password"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            outlined
            label="Repetir senha"
            class="required"
            type="password"
            minlength="8"
            maxlength="30"
            autocomplete="new-password"
            :error="$v.empresa.usuario.matchPassword.$error"
            @blur="$v.empresa.usuario.matchPassword.$touch()"
            v-model="empresa.usuario.matchPassword"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-btn color="primary"
           class="mr-2"
           v-if="!hideControls"
           :disabled="$v.$invalid"
           @click="emitReady">
      Próximo
    </v-btn>
  </v-form>
</template>

<script>
import {
  required, email, sameAs, minLength, maxLength,
} from 'vuelidate/lib/validators';
import { isPasswordValid } from '@/utils/validate-password';
import { isValid } from '@/utils/validate-cpf';

export default {
  props: {
    empresa: {
      type: Object,
      required: true,
    },
    hideControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordMessages: ['Deve possuir letra maiúscula, minúscula e números. Entre 8 e 30 caracteres'],
    };
  },
  methods: {
    emitReady() {
      this.$emit('ready');
    },
    emitBack() {
      this.$emit('back');
    },
  },
  validations: {
    empresa: {
      usuario: {
        nome: {
          required,
        },
        cpf: {
          required,
          validateCpf(value) {
            return isValid(value);
          },
        },
        email: {
          required,
          email,
        },
        password: {
          required,
          minLength: minLength(8),
          maxLength: maxLength(30),
          passwordValid(value) {
            return isPasswordValid(value);
          },
        },
        matchPassword: {
          required,
          sameAsPassword: sameAs('password'),
        },
      },
    },
  },
};
</script>
